import { FactionJsonldSeasonPassUserRead } from '@/api/generated';
import { SIZE } from '@/types/utils';
import clx from 'classnames';
import FactionIcon from '../FactionIcon';

type Props = {
  faction: FactionJsonldSeasonPassUserRead;
  size?: SIZE;
};

const SIZE_TO_CLASS = {
  [SIZE.SM]: 'w-7 h-7 p-1',
  [SIZE.MD]: 'w-9 h-9 p-2',
  [SIZE.LG]: 'w-12 h-12 p-3',
};

const SIZE_TO_ICON_CLASS = {
  [SIZE.SM]: 'text-lg',
  [SIZE.MD]: 'text-2xl',
  [SIZE.LG]: 'text-3xl',
};

const FactionBadge = ({ faction, size = SIZE.MD }: Props) => (
  <div
    className={clx('flex items-center justify-center rounded-full', SIZE_TO_CLASS[size])}
    style={{ backgroundColor: faction.color || undefined }}
  >
    <FactionIcon className={clx('text-white', SIZE_TO_ICON_CLASS[size])} name={faction.reference} />
  </div>
);

export default FactionBadge;
